"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terraDescribePath = void 0;
const utils_1 = require("./utils");
function terraDescribePath(path) {
    let pathStr = utils_1.addressNListToBIP32(path);
    let unknown = {
        verbose: pathStr,
        coin: "Terra",
        isKnown: false,
    };
    if (path.length != 5) {
        return unknown;
    }
    if (path[0] != 0x80000000 + 44) {
        return unknown;
    }
    if (path[1] != 0x80000000 + utils_1.slip44ByCoin("Terra")) {
        return unknown;
    }
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) {
        return unknown;
    }
    if (path[3] !== 0 || path[4] !== 0) {
        return unknown;
    }
    let index = path[2] & 0x7fffffff;
    return {
        verbose: `Terra Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Terra",
        isKnown: true,
        isPrefork: false,
    };
}
exports.terraDescribePath = terraDescribePath;
